import { createContext, type ReactNode, useContext } from "react";

import type { BoardHubServices } from "./types.js";

const BoardHubContext = createContext<BoardHubServices | null>(null);

export function BoardHubProvider({
  value,
  children,
}: {
  value: BoardHubServices;
  children: ReactNode;
}) {
  return <BoardHubContext.Provider value={value}>{children}</BoardHubContext.Provider>;
}

/**
 * Read the hub-injected `BoardHubServices` port (ADR-0101 Phase 5b).
 * Every Board component that needs a hub-owned domain (auth, workspaces,
 * Ask Insights) calls this instead of importing `packages/web/src/**`
 * directly.
 */
export function useBoardHub(): BoardHubServices {
  const ctx = useContext(BoardHubContext);
  if (!ctx) {
    throw new Error("useBoardHub must be used within <BoardHubProvider>");
  }
  return ctx;
}
